

function medianAgeFromRange(ageRange) {
  if (typeof ageRange === 'number') return ageRange;
  switch (ageRange) {
    case "18-30":
      return 24;
    case "31-60":
      return 45.5;
    case "60+":
      return 65;
    default:
      if (typeof ageRange === 'string' && ageRange.includes('-')) {
        const [min, max] = ageRange.split('-').map(Number);
        if (!isNaN(min) && !isNaN(max)) {
          return (min + max) / 2;
        }
      }
      return 30;
  }
}

export function getBaseMetabolicRate(age, height, weight, gender) {
  const numericAge = medianAgeFromRange(age);
  if (gender === "male") {
    return 10 * weight + 6.25 * height - 5 * numericAge + 5;
  } else {
    return 10 * weight + 6.25 * height - 5 * numericAge - 161;
  }
}

export function getDailyNeeds(tmb, nap) {
    return tmb * nap;
}

export function getTargetCalories(dailyNeeds, goal) {
    switch (goal) {
        case "loseWeight":
            return dailyNeeds - 380;
        case "maintainWeight":
            return dailyNeeds;
        case "gainWeight":
            return dailyNeeds + 380;
        default:
            return dailyNeeds;
    }
}

export function calculateBmiData(height, weight) {
  const h = height / 100;
  const bmi = weight / (h * h);

  let status;
  if (bmi < 18.5) status = "Insuffisance pondérale";
  else if (bmi < 25) status = "Poids normal";
  else if (bmi < 30) status = "Surpoids";
  else if (bmi < 35) status = "Obésité";
  else status = "Obésité morbide";

  let percent = Math.min((bmi / 50) * 100, 100);
  if (percent >= 100) {
    percent = 99;
  } else if (percent <= 0) {
    percent = 1;
  }

  return { bmi, status, percent };
}

export function calculateMacros(weight, activityLevel, weightObjective, targetCalories) {
  // Protéines
  let gramsPerKg = 1.2;
  if (activityLevel === "moderatelyActive") gramsPerKg = 1.6;
  if (activityLevel === "veryActive" || weightObjective === "gainWeight") gramsPerKg = 2;

  const proteinNeeds = gramsPerKg * weight;
  const proteinCalories = proteinNeeds * 4;

  // Lipides : 30% des calories
  const fatCalories = targetCalories * 0.3;
  const fatNeeds = fatCalories / 9;

  // Glucides = reste
  const carbCalories = targetCalories - (proteinCalories + fatCalories);
  const carbNeeds = carbCalories / 4;

  return {
    proteinNeeds,
    proteinCalories,
    fatNeeds,
    fatCalories,
    carbNeeds,
    carbCalories,
  };
}
